import * as React from "react";
import { PaperProps, Paper } from "@mui/material";
export default function Panel(props: PaperProps) {
  return (
    <Paper style={{ padding: 24 }} {...props}>
      {props.children}
    </Paper>
  );
}
